import { Core4Metric } from '../../../model/Entities';

/** ACCURACY **/

export const lacrosseCore4MetricShotVeloR: Core4Metric = {
    code: 'SHOTVELOR',
    categoryCode: 'ACCURACY',
    sportCode: 'LACROSSE',
    name: 'Shot Velo R',
    best: 'max',
    comparable: true,
};

export const lacrosseCore4MetricShotVeloL: Core4Metric = {
    code: 'SHOTVELO',
    categoryCode: 'ACCURACY',
    sportCode: 'LACROSSE',
    name: 'Shot Velo L',
    best: 'max',
    comparable: true,
};

export const lacrosseCore4MetricWallBallTestR: Core4Metric = {
    code: 'WALLBALLTESTR',
    categoryCode: 'ACCURACY',
    sportCode: 'LACROSSE',
    name: 'Wall Ball Test R',
    best: 'max',
    comparable: true,
};

export const lacrosseCore4MetricWallBallTestL: Core4Metric = {
    code: 'WALLBALLTEST',
    categoryCode: 'ACCURACY',
    sportCode: 'LACROSSE',
    name: 'Wall Ball Test L',
    best: 'max',
    comparable: true,
};

/** SPEED **/

export const lacrosseCore4Metric10YD: Core4Metric = {
    code: '10YD',
    categoryCode: 'SPEED',
    sportCode: 'LACROSSE',
    name: '10 Yard Dash',
    best: 'min',
    comparable: true,
};

export const lacrosseCore4Metric40YD: Core4Metric = {
    code: '40YD',
    categoryCode: 'SPEED',
    sportCode: 'LACROSSE',
    name: '40 Yard Dash',
    best: 'min',
    comparable: true,
};

/** AGILITY **/

export const lacrosseCore4Metric5105: Core4Metric = {
    code: '5105',
    categoryCode: 'AGILITY',
    sportCode: 'LACROSSE',
    name: '5-10-5',
    best: 'min',
    comparable: true,
};

export const lacrosseCore4MetricTDrill: Core4Metric = {
    code: 'TDRILL',
    categoryCode: 'AGILITY',
    sportCode: 'LACROSSE',
    name: 'T Drill',
    best: 'min',
    comparable: true,
};

/** STRENGTH **/

export const lacrosseCore4MetricVerticalJump: Core4Metric = {
    code: 'VERTICALJUMP',
    categoryCode: 'STRENGTH',
    sportCode: 'LACROSSE',
    name: 'Vertical Jump',
    best: 'max',
    comparable: true,
};

export const lacrosseCore4MetricHandGripRT: Core4Metric = {
    code: 'HANDGRIPRT',
    categoryCode: 'STRENGTH',
    sportCode: 'LACROSSE',
    name: 'Hand Grip Strength (RT)',
    best: 'max',
    comparable: true,
};

export const lacrosseCore4MetricHandGripLT: Core4Metric = {
    code: 'HANDGRIPLT',
    categoryCode: 'STRENGTH',
    sportCode: 'LACROSSE',
    name: 'Hand Grip Strength (LT)',
    best: 'max',
    comparable: true,
};

export const lacrosseCore4MetricBroadJump: Core4Metric = {
    code: 'BROADJUMP',
    categoryCode: 'STRENGTH',
    sportCode: 'LACROSSE',
    name: 'Broad Jump',
    best: 'max',
    comparable: true,
};
